import React, { useEffect, useRef } from "react";

type Props = {
  cart?: {
    products?: Array<Record<string, any>>;
    totalResellerProfit?: number;
    delivery?: { price?: number };
  };
};

const CartBottomCard = ({ cart }: Props) => {
  const init = useRef({});

  const calculateProductTotal = (products: any[]) => {
    if (!products || products.length === 0) return 0;

    return products.reduce((total: number, product: any) => {
      const price = Number(product.newPrice ?? product.productPrice ?? 0) || 0;
      const quantity = Number(product.productQty ?? product.quantity ?? 0) || 0;
      return total + price * quantity;
    }, 0);
  };

  const productTotal = calculateProductTotal(cart?.products ?? []);

  useEffect(() => {
    init.current = {};
  }, []);

  return (
    <div
      className="rounded-t-md flex flex-col left-0 bottom-0 inset-x-0 bg-white w-full lg:max-w-7xl lg:mx-auto font-nunito"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex flex-col space-y-4 p-4">
        <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">Gross</span>
          <span className="text-body1 font-semi text-blackText">
            {cart?.products?.[0]?.currency ?? "GH₵"} {productTotal.toFixed(2)}
          </span>
        </div>
        {/* <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">My Profit</span>
          <span className="text-body1 font-semi text-blackText">
            {cart?.products?.[0]?.currency ?? "GH₵"} {Number(cart?.totalResellerProfit ?? 0).toFixed(2)}
          </span>
        </div> */}
        <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">Delivery Fee</span>
          <span className="text-body1 font-semi text-blackText">
            {cart?.products?.[0]?.currency ?? "GH₵"} {Number(cart?.delivery?.price ?? 0).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CartBottomCard;
